module.exports = __webpack_public_path__ + "img/DBC.817c9588.svg";